import { EntitySelector as EntitySelectorBase } from '@domain-group/suit-theme'
import type { EntitySelectorProps as EntitySelectorBaseProps, FormFieldProps } from '@domain-group/suit-theme'

import searchEndpoint from '@functions/search'

import useReduxAction from '@hooks/useReduxAction'
import useSelector from '@hooks/useSelector'

import entitySettings from './entitySettings'

type Callbacks = { callbacks: Omit<EntitySelectorBaseProps['callbacks'], 'search'> }

type EntitySelectorProps = Omit<EntitySelectorBaseProps, 'entities' | 'entitySettings' | 'useReduxAction' | 'callbacks'>
  & Partial<FormFieldProps>
  & Callbacks

const EntitySelector = (props: EntitySelectorProps) => {
  const { callbacks, ...restProps } = props

  const entities = useSelector(reduxState => reduxState.entities)

  return (
    <EntitySelectorBase
      // @ts-expect-error TS2322
      callbacks={{ ...callbacks, search: searchEndpoint }}
      // @ts-expect-error TS2322
      entities={entities}
      entitySettings={entitySettings}
      // @ts-expect-error TS2322
      useReduxAction={useReduxAction}
      {...restProps}
    />
  )
}

EntitySelector.CreateEntity = EntitySelectorBase.CreateEntity

export default EntitySelector
